import React from 'react';
import I18n from 'i18n-js';
import { RCGrid, RCImage } from '@reverbdotcom/cadence/components';
import { OverflowingRow } from '@reverbdotcom/commons';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { AppleAppStoreLink, GooglePlayStoreLink } from '../../shared/app_store_links';
import { preferLightTheme } from '@reverbdotcom/cadence/components/helpers/themeOverrides';

const CALLOUT_IMAGE = 'https://res.cloudinary.com/reverb-marketing/image/upload/v1710522555/Logged%20Out%20Homepage/App%20Banner/logged-out-homepage-app-desktop-380x325-2X.png';
const CALLOUT_IMAGE_MOBILE = 'https://res.cloudinary.com/reverb-marketing/image/upload/v1710522775/Logged%20Out%20Homepage/App%20Banner/logged-out-homepage-app-mobile-353x200.png';
const CALLOUT_QR_IMAGE = 'https://res.cloudinary.com/reverb-marketing/image/upload/v1710522805/Logged%20Out%20Homepage/App%20Banner/app-download-qr-6763560aa083c2f2.svg';

export default function AppCallout() {
  const user = useUser();

  return (
    <OverflowingRow>
      <div className="app-callout">
        <RCGrid flexboxItems={true}>
          <RCGrid.Item colSpan={{ desktop: 2, tablet: 3 }} hideOn="mobile">
            <div className="app-callout__qr-code-container">
              <div className="app-callout__qr-code">
                <div className="app-callout__qr-code-text">
                  {I18n.t('discovery.homepage.appCallout.qrCodeHelperText')}
                </div>
                <RCImage
                  src={CALLOUT_QR_IMAGE}
                  alt={I18n.t('discovery.homepage.appCallout.qrCodeHelperText')}
                  imageBox="auto"
                />
              </div>
            </div>
          </RCGrid.Item>
          <RCGrid.Item colSpan={{ desktop: 6, tablet: 5, mobile: 12 }}>
            <div className="app-callout__inner" {...preferLightTheme()}>
              <div className="app-callout__inner-text">
                <div className="app-callout__title">{I18n.t('discovery.homepage.appCallout.title')}</div>
                <div className="app-callout__subtitle">{I18n.t('discovery.homepage.appCallout.subtitle')}</div>
              </div>
              <div className="app-callout__app-store-badges">
                <AppleAppStoreLink userLocale={user.locale} linkLocation="homepage-experiment" />
                <GooglePlayStoreLink userLocale={user.locale} linkLocation="homepage-experiment" />
              </div>
              <div className="app-callout__mobile-image">
                <RCImage src={CALLOUT_IMAGE_MOBILE} imageBox="auto"/>
              </div>
            </div>
          </RCGrid.Item>
          <RCGrid.Item colSpan={{ desktop: 4, tablet: 4 }} hideOn="mobile">
            <div
              className="app-callout__image"
              style={{ backgroundImage: `url(${CALLOUT_IMAGE})` }} />
          </RCGrid.Item>
        </RCGrid>
      </div>
    </OverflowingRow>
  );
}
